import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDepartments, saveDepartment } from '../../../../features/departments/departmentActions';
import { clearDepartmentSaveError } from '../../../../features/departments/departmentSlice';
import { getUsersAsync } from '../../../../features/users/usersActions';
import Toast from '../../../../components/Toast';
const Context = createContext(null);
export function DepartmentProvider({ children }) {
  const dispatch = useDispatch();
  const state = useSelector(state => state.departments);
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('');
  const [form, setForm] = useState(null);
  const pending = useRef(false), active = useRef(true);
  useEffect(() => { active.current = true; const request = dispatch(fetchDepartments()); return () => { active.current = false; request.abort(); }; }, [dispatch]);
  const openForm = item => { dispatch(clearDepartmentSaveError()); setForm(item ? { ...item } : { name: '', isActive: true }); };
  const closeForm = () => { if (!pending.current) setForm(null); };
  const updateField = (name, value) => setForm(previous => ({ ...previous, [name]: value }));
  const submit = async event => {
    event.preventDefault(); if (pending.current) return; pending.current = true;
    try {
      await dispatch(saveDepartment({ id: form.id, data: { name: form.name, isActive: form.isActive, version: form.version } })).unwrap();
      dispatch(getUsersAsync());
      if (active.current) { setForm(null); Toast('success', 'Department saved successfully.'); }
    } catch (_) { /* The slice preserves the form and exposes the error. */ }
    finally { pending.current = false; }
  };
  const rows = state.items.filter(item => item.name.toLowerCase().includes(search.trim().toLowerCase()) && (!status || String(item.isActive) === status)).sort((a, b) => a.name.localeCompare(b.name));
  return <Context.Provider value={{ ...state, rows, search, setSearch, status, setStatus, form, openForm, closeForm, updateField, submit, reload: () => dispatch(fetchDepartments()) }}>{children}</Context.Provider>;
}
export const useDepartments = () => useContext(Context);
